module.exports = __webpack_public_path__ + "static/altana-wnetrze-32313a7288fa27071def9e12fe17e07c.jpg";